import { render } from "./MerchantPurchaseDetail.vue?vue&type=template&id=4de6ccad&scoped=true"
import script from "./MerchantPurchaseDetail.vue?vue&type=script&lang=js"
export * from "./MerchantPurchaseDetail.vue?vue&type=script&lang=js"

import "./MerchantPurchaseDetail.vue?vue&type=style&index=0&id=4de6ccad&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de6ccad"]])

export default __exports__